/**
 * DEVELOPMENT
 */

// Enable webpack HMR for extracted reelements
module.hot && module.hot.accept()

if (DEVELOPMENT && module.hot) {
  console.log(
    `%c Run development ${VERSION} on ${location.origin} `,
    'background:tomato; color:white; display:block; padding:2px'
  )
}

// import '@/styles/app.scss'

/**
 * SVG https://github.com/svgstore/webpack-svgstore-plugin
 */
// import svgstore from '@/vendors/svgxhr'
// const __svg__ = {
//   path: 'sprites/logos/*.svg',
//   name: 'logos.sprite.svg' // 'logos.sprite.[hash].svg'
// }
// // svgstore(__svg__)
// if (DEVELOPMENT && module.hot) {
//   svgstore(`/logos.sprite.svg`)
// }

/**
 * App
 */
import '@/helpers/dom'
import '@/helpers/target-blank';
import transitionEnd from '@/helpers/transition'
import animationEnd from '@/helpers/animation'

import { touchAction } from '@/vendors/touch-action'
touchAction()

// const responsiveImage = require('@/images/intro-1080p-color-md.jpg?sizes[]').srcSet;
// console.log(responsiveImage);

// import heroImage from '@/images/intro-1080p-color-md.jpg?{"sizes": [480, 960]}'
// console.log(heroImage)

/** 
 * Cache base elements
 */
const $html = qs('html')
const $body = qs('body')
const $app = qs('#app')
const $header = qs('.js-header')
const $headerNavTrigger = qs('.js-header-nav-trigger')
const $headerNav = qs('.js-header-nav')
const $headerNavItems = Array.from(qsa('.js-header-nav ul a[href^="#"]'))

/** 
 * Document loaded
 */
console.time('DOMContentLoaded')
document.addEventListener('DOMContentLoaded', e => {
  $html.classList.remove('is-loading')
  // $app.style.visibility = 'initial';
  // qs('.loader').style.display = 'none';
  console.timeEnd('DOMContentLoaded')
});

/*
const responsiveImage = require('@/images/i001.jpg?sizes[]').srcSet;
console.log(responsiveImage);
// export {responsiveImage};
import heroImage from '@/images/i001.jpg?{"sizes": [300, 480, 768, 960]}'
console.log(heroImage)
export {heroImage}
*/

/**
 * We use https://polyfill.io/v2/polyfill.min.js?features=IntersectionObserver
 */

/**
 * Sticky polyfill
 * https://github.com/wilddeer/stickyfill
 */
import Stickyfill from 'stickyfilljs'
const stickyEls = qsa('.sticky')
Stickyfill.add(stickyEls)

/**
 * Smooth Scroll polyfill
 * https://github.com/iamdustan/smoothscroll
 * Force polyfill implementation
 * window.__forceSmoothScrollPolyfill__ = true;
 */
require('smoothscroll-polyfill').polyfill()

// Получает хэш, вычисляет позицию относительно документа, скроллит
import { getCoords } from '@/helpers/getCoords';
const scrollToHash = hash => {
  if (!qs(hash)) return false;
  const offset = getCoords(qs(hash)).top - $header.offsetHeight
  // console.log(offset)
  window.scroll({
    top: offset,
    left: 0,
    behavior: 'smooth'
  })
};

// Скроллим к элементу при загрузке страницы, 
// если элемент есть, а в адресной строке есть на него ссылка
window.addEventListener('load', () => {
  window.location.hash && scrollToHash(location.hash)
})

window.addEventListener('hashchange', () => {
  window.location.hash && scrollToHash(location.hash)
})

const headerNavState = e => {
  e.preventDefault()
  if (window.matchMedia('(max-width: 767px)').matches) {
    console.log('matches')
    $html.classList.toggle('is-disabled')
    $html.classList.toggle('is-menu-open')
    $headerNavTrigger.classList.toggle('is-active')
    $headerNav.scrollTop = 0;
  }
}

/**
 * Header nav list
 * скролл к элементу на клики с хэшами
 */
$headerNavItems.forEach(target =>
  target.on('click', e => {
    headerNavState(e)
    history.pushState(null, null, e.target.hash);
    scrollToHash(e.target.hash)
  })
);

/**
 * Header nav trigger
 * открывает/закрывает меню
 */
$headerNavTrigger.on('click', e => headerNavState(e))

/**
 * Возвращает меню в дефолтное состояние
 * если размер окна изменился в большую сторону
 */
function debounce(cb, interval) {
  let timeout;
  return function() {
    clearTimeout(timeout)
    timeout = setTimeout(cb.apply.bind(cb, this, arguments), interval)
  }
}

window.addEventListener('resize', debounce(e => {
  if (window.matchMedia('(min-width: 768px)').matches) {
    $html.classList.remove('is-disabled', 'is-menu-open')
    $headerNavTrigger.classList.remove('is-active')
    $headerNav.scrollTop = 0;
  }
}, 100));

/**
 * ScrollSpy
 * Highlight nav item then section into viewport
 * optional: Animate Section then his into viewport
 */
(() => {
  const setActiveNavItem = id => {
    $headerNavItems.forEach(nav => nav.classList.remove('is-active'))
    $headerNavItems.filter(nav => (nav.hash.slice(1) == id) && nav.classList.add('is-active'))
  }

  const observer = new IntersectionObserver(changes =>
    changes.forEach(change => {
      if (change.isIntersecting) {
        change.target.classList.add('in-view')
        setActiveNavItem(change.target.id)
      } else {
        change.target.classList.remove('in-view')
      }
    }), { rootMargin: '-30% 0%' })

  const animations = Array.from(qsa('.l-section[id]'))
  animations.forEach(item => observer.observe(item))
})();

/**
 * Goto top of page
 */
qs('.js-goto-top').on('click', e => {
  e.preventDefault()
  window.scroll({ top: 0, left: 0, behavior: 'smooth' })
});

/*
 * Animate Directions
 * https://github.com/w3c/IntersectionObserver/blob/gh-pages/explainer.md
 */
/*
const animateStepByStep = ($items, step = 500) => {
  let delay = 0
  if ($items.length > 0) $items.forEach($item => {
    // добавим класс по новой
    if (!$item.classList.contains('-out')) $item.classList.add('-out');
    // анимируем появление
    setTimeout(() => $item.classList.remove('-out'), delay * step)
    delay++
  })
}
const animationObserver = () => {
  const $directionList = Array.from(qsa('.js-direction b'));
  setTimeout(() => animateStepByStep($directionList, 200), 500);
  const $circleList = Array.from(qsa('.js-direction circle'));
  setTimeout(() => animateStepByStep($circleList, 500), 1000);
}

(() => {
  const animations = Array.from(qsa('.js-direction'))
  // const content = animations[0].innerHTML

  const observer = new IntersectionObserver(changes =>
    changes.forEach(change => {
      if (change.isIntersecting) {
        animationObserver()
        observer.unobserve(change.target)
      }
      // if (change.intersectionRatio > 0) {
      //   animations[0].innerHTML = content
      //   change.target.classList.remove('is-stopped')
      //   animationObserver()
      // } else {
      //   change.target.classList.add('is-stopped')
      //   // animations[0].innerHTML = content
      // }
    }), { rootMargin: '-30% 0%' })

  // const animations = Array.from(qsa('.js-animate'))
  animations.forEach(item => observer.observe(item))
})();*/

/**
 * Lazy loading images
 */
/*import lozad from '@/vendors/lozad'
lozad('[data-src]', {
  rootMargin: '100% 0px',
  threshold: 0.1,
  load(el) {
    console.log('loading element', el)
    // Custom implementation to load an element
    // el.src = el.dataset.src
    // el.classList.add('loaded')
    const dataSrc = el.dataset.src
    const fake = new Image()
    fake.src = dataSrc
    fake.onload = () => {
      el.src = dataSrc
      el.classList.add('loaded')
    }
  }
}).observe()*/

(() => {
  const observer = new IntersectionObserver(changes =>
    changes.forEach(change => {
      const target = change.target
      const dataSrc = target.dataset.src
      if (change.isIntersecting) {
        const fake = new Image()
        fake.src = dataSrc
        fake.onload = () => {
          // console.log('loaded', fake)
          target.src = dataSrc
          target.classList.add('loaded')
          observer.unobserve(target)
        }
      }
    }), { rootMargin: '50% 0px', threshold: 0.15 })

  const lazyImages = Array.from(qsa('[data-src]'))
  lazyImages.forEach(item => observer.observe(item))
})();



// WEBPACK FOOTER //
// ./main.js